import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Form, Button, Row, Col, Spinner, Image, Modal  } from "@themesberg/react-bootstrap";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";

export default function ProdukForm() {
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();
  const token = localStorage.getItem("token");

  const [mode, setMode] = useState("add");
  const [produk, setProduk] = useState({
    nama: "",
    komposisi: "",
    kelebihan: "",
    fungsi: "",
    cara_penggunaan: "",
    harga_stokis: "",
    harga_reseller: "",
    harga_agen: "",
  });
  const [gambar, setGambar] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  useEffect(() => {
    if (id) {
      setLoading(true);
      setMode(location.pathname.includes("edit") ? "edit" : "view");

      fetch(`${process.env.REACT_APP_API_URL}/produk/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => res.json())
        .then((data) => setProduk(data))
        .catch((err) => console.error("Gagal ambil detail produk:", err))
        .finally(() => setLoading(false));
    } else {
      setMode("add");
    }
  }, [id, location.pathname]);

  const handleChange = (e) => {
    setProduk({ ...produk, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    setPreview(URL.createObjectURL(file));
    setGambar(file); // ✅ simpan file-nya ke state gambar
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    const method = id ? "PUT" : "POST";
    const url = id
      ? `${process.env.REACT_APP_API_URL}/produk/${id}`
      : `${process.env.REACT_APP_API_URL}/produk`;

    // 🔥 gunakan FormData, bukan JSON
    const formData = new FormData();
    formData.append("nama", produk.nama);
    formData.append("komposisi", produk.komposisi);
    formData.append("kelebihan", produk.kelebihan);
    formData.append("fungsi", produk.fungsi);
    formData.append("cara_penggunaan", produk.cara_penggunaan);
    formData.append("harga_stokis", produk.harga_stokis);
    formData.append("harga_reseller", produk.harga_reseller);
    formData.append("harga_agen", produk.harga_agen);
    if (gambar) {
      formData.append("gambar", gambar);
    }

    try {
      const response = await fetch(url, {
        method,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (response.ok) {
        alert(id ? "Produk berhasil diperbarui ✅" : "Produk berhasil ditambahkan ✅");
        history.push("/produk");
      } else {
        const errMsg = await response.text();
        console.error("Gagal simpan produk:", errMsg);
        alert("Terjadi kesalahan saat menyimpan produk ❌");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <Card border="light" className="bg-white shadow-sm mb-4">
      <Card.Body>
        <h5 className="mb-4">
          {mode === "add"
            ? "Tambah Produk"
            : mode === "view"
              ? "Detail Produk"
              : "Edit Produk"}
        </h5>

        <Form onSubmit={handleSubmit}>
          <Row>
            <Col className="mb-3">
              <Form.Group>
                <Form.Label>Nama</Form.Label>
                <Form.Control
                  name="nama"
                  value={produk.nama}
                  onChange={handleChange}
                  disabled={mode === "view"}
                  required
                  placeholder="Masukkan nama produk"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col className="mb-3">
              <Form.Group>
                <Form.Label>Komposisi</Form.Label>
                <Form.Control
                  as="textarea"
                  name="komposisi"
                  value={produk.komposisi}
                  onChange={handleChange}
                  rows={3}
                  disabled={mode === "view"}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col className="mb-3">
              <Form.Group>
                <Form.Label>Kelebihan</Form.Label>
                <Form.Control
                  as="textarea"
                  name="kelebihan"
                  value={produk.kelebihan}
                  onChange={handleChange}
                  rows={3}
                  disabled={mode === "view"}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col className="mb-3">
              <Form.Group>
                <Form.Label>Fungsi</Form.Label>
                <Form.Control
                  as="textarea"
                  name="fungsi"
                  value={produk.fungsi}
                  onChange={handleChange}
                  rows={3}
                  disabled={mode === "view"}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col className="mb-3">
              <Form.Group>
                <Form.Label>Cara Penggunaan</Form.Label>
                <Form.Control
                  as="textarea"
                  name="cara_penggunaan"
                  value={produk.cara_penggunaan}
                  onChange={handleChange}
                  rows={3}
                  disabled={mode === "view"}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col className="mb-3">
              <Form.Group>
                <Form.Label>Harga Stokis</Form.Label>
                <Form.Control
                  type="number"
                  name="harga_stokis"
                  value={produk.harga_stokis}
                  onChange={handleChange}
                  disabled={mode === "view"}
                  required
                  placeholder="Masukkan harga stokis"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col className="mb-3">
              <Form.Group>
                <Form.Label>Harga Reseller</Form.Label>
                <Form.Control
                  type="number"
                  name="harga_reseller"
                  value={produk.harga_reseller}
                  onChange={handleChange}
                  disabled={mode === "view"}
                  required
                  placeholder="Masukkan harga reseller"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col className="mb-3">
              <Form.Group>
                <Form.Label>Harga Agen</Form.Label>
                <Form.Control
                  type="number"
                  name="harga_agen"
                  value={produk.harga_agen}
                  onChange={handleChange}
                  disabled={mode === "view"}
                  required
                  placeholder="Masukkan harga agen"
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Upload gambar */}
          <Row>
            <Col className="mb-3">
              <Form.Group>
                <Form.Label>Gambar</Form.Label>
                <Card border="light" className="bg-white shadow-sm mb-4">
                  <Card.Body>
                    <div className="d-xl-flex align-items-center">
                      <div className="user-avatar xl-avatar">
                        {preview ? (
                          <Image
                            fluid
                            rounded
                            src={preview}
                            onClick={handleShowModal}
                            style={{ cursor: "pointer", maxWidth: "100px" }}
                          />
                        ) : produk.gambar ? (
                          <Image
                            fluid
                            rounded
                            src={`${process.env.REACT_APP_API_URL_IMAGE}/public/uploads/produk/${produk.gambar}`}
                            onClick={handleShowModal}
                            style={{ cursor: "pointer", maxWidth: "100px" }}
                          />
                        ) : (
                          <div className="text-muted">Belum ada gambar</div>
                        )}

                      </div>

                      <div className="file-field">
                        <div className="d-flex justify-content-xl-center ms-xl-3">
                          <div className="d-flex align-items-center">
                            <FontAwesomeIcon icon={faPaperclip} className="me-3" />
                            <input
                              type="file"
                              accept="image/*"
                              onChange={handleFileChange}
                              disabled={mode === "view"}
                            />
                            <div className="d-md-block text-start ms-2">
                              <div className="fw-normal text-dark mb-1">
                                Pilih gambar
                              </div>
                              <div className="text-gray small">
                                JPG, GIF, atau PNG. Maks 2MB
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Form.Group>
            </Col>
          </Row>

          {/* Tombol submit */}
          {mode === "view" ? (
            <div className="mt-3 text-end">
              <Button variant="secondary" onClick={() => history.push("/produk")}>
                Kembali
              </Button>
            </div>
          ) : (
            <div className="mt-3 text-end">
              <Button variant="primary" type="submit">
                {id ? "Update" : "Simpan"}
              </Button>{" "}
              <Button variant="secondary" onClick={() => history.push("/produk")}>
                Batal
              </Button>
            </div>
          )}
        </Form>
      </Card.Body>

      {/* Modal untuk menampilkan gambar besar */}
<Modal show={showModal} onHide={handleCloseModal} centered size="lg">
  <Modal.Body className="text-center">
    <Image
      fluid
      src={
        preview
          ? preview
          : produk.gambar
          ? `${process.env.REACT_APP_API_URL_IMAGE}/public/uploads/produk/${produk.gambar}`
          : "https://via.placeholder.com/500"
      }
      rounded
      style={{ maxHeight: "80vh", objectFit: "contain" }}
    />
  </Modal.Body>
</Modal>


    </Card>
  );
}
